import React, { Component } from 'react'
import '../styles/LearnMoreButton.css'

class LearnMoreButton extends Component {
  render() {
    const glitchStyle = this.props.glitch ? "learn-more-glitch" : null
    const glitched = this.props.glitch ? "glitched" : null

    return (
      <div className={`learn-more ${this.props.styleClass} ${glitched}`}>
        <span data-text={this.props.text} className={glitchStyle}>{this.props.text}</span>
      </div>
    );
  }
}

export default LearnMoreButton;



// WEBPACK FOOTER //
// ./src/components/LearnMoreButton.js